import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import OptimizedForCostImage from './OptimizedForCostImage'

const copy = {
  heading: `Optimized for cost and performance`,
  description: `Schematized for easy querying across the customer journey.`,
}

const OptimizedForCost = () => {
  return (
    <SectionBase variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <OptimizedForCostImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default OptimizedForCost
